<template>
    <div class="pt15">
        <div class="sub_title">
           배송 정보
            <div class="fs13 input_error pl0">배송 정보 수정시 해당 주문 번호 내 모든 상품에 대해 일괄 변경 됩니다.</div>
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tbody>
                <tr>
                    <td class="c_t_title">수령인명</td>
                    <td>
                        <div class="d_block">
                          {{ orderData.recieverName }}
                        </div>
                    </td>
                    <td class="c_t_title">수령인 전화번호</td>
                    <td>
                        <div class="d_block">
                            {{ phoneFormatter(orderData.recieverPhone) }}
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="c_t_title">배송지주소</td>
                    <td colspan="3">
                        <div class="d_block search">
                            <el-input class="table_s_input mr10" v-model="zipCode" ></el-input>
                            <el-button type="primary" @click="openDaumModal">우편번호 검색 ></el-button>
                            <el-input class="mt10" v-model="address"></el-input>
                            <el-input class="mt10" v-model="addressDetail" @change="parentChange('addressDetail', addressDetail)"></el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">배송 요청 사항</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{orderData.shippingRequest}}
                        </div>
                    </td>
                </tr>
                <tr v-if="!isEmptyReason()">
                    <td class="c_t_title">직접 입력 내용</td>
                    <td colspan="3">
                        <div class="d_block" v-html="replaceBr(orderData.shippingMemo)"></div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <daum-postcode-modal></daum-postcode-modal>
    </div>
</template>

<script>

import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import DaumPostcodeModal from "@/components/modal/DaumPostcodeModal.vue";
import numberHyphen from "@/mixins/numberHyphen";
import contentMixins from "@/mixins/contentMixins";
import SimpleVueValidation from "simple-vue-validator";
import Vue from "vue";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    name: "ShippingInformationLayout",
    mixins: [numberHyphen, contentMixins],
    components: {DaumPostcodeModal},
    inject: [],
    provide() {
        return {}
    },
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        orderData: {
            default: () => {
            }, type: Object
        },
        orderClass: {default: null,},
    },
    data() {
        return {
            // 배송정보
            zipCode:'',
            address:'',
            addressDetail:'',
            shippingMemo:'',
            validatorArr:['zipCode', 'address', 'addressDetail', 'shippingMemo'],

        }
    },
    beforeRouterEnter() {
    },
    created() {
        if(this.isOrderData()){
            this.InitData();
        }
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('ShippingInformationLayout')
        EventBus.$on('setAddress', this.setAddress);
    },
    beforeDestroy() {
        EventBus.$off('setAddress');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        isOrderData() {
            return !util.isEmpty(this.orderData);
        },
        InitData() {
            this.zipCode = this.orderData.zipCode
            this.parentChange('zipCode', this.zipCode);
            this.address = this.orderData.address
            this.parentChange('address', this.address);
            this.addressDetail = this.orderData.addressDetail
            this.parentChange('addressDetail', this.addressDetail);
            this.shippingMemo = this.orderData.shippingMemo
            this.parentChange('shippingMemo', this.shippingMemo);
        },
        openDaumModal(){
            this.$modal.show('daum-postcode-modal');
        },
        setAddress(addrObj) {
            this.zipCode = addrObj.zonecode;
            this.address = addrObj.roadAddress;
            this.addressDetail = ''

            this.parentChange('zipCode', this.zipCode);
            this.parentChange('address', this.address);
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        checkValidator() {
            this.$validate(['zipCode', 'address', 'addressDetail', 'shippingMemo'])
        },
        isEmptyReason() {
            return util.isEmpty(this.orderData.shippingMemo);
        },
    },
    watch: {},
    validators: {
        zipCode: function (value) {
            return Validator.value(value)
                .required('주소를 입력하세요.')
        },
        address: function (value) {
            return Validator.value(value)
        },
        addressDetail: function (value) {
            return Validator.value(value)
        },
        shippingMemo: function (value) {
            return Validator.value(value)
        },
    },
}
</script>

<style scoped>

</style>
